import { Card, CardBody, CardTitle, Col, Container, Row } from "react-bootstrap";
import { IBlogsCubit } from "../blocs/blog/BlogsBloc";
import { BlogsState } from "../blocs/blog/blogStates";
import useCubit from "../blocs/hooks";
import { kNavBarHeight } from "../core/utils/constants";
import BlogElement from "./BlogElement";
import CategoryBadge from "./CategoryBadge";

interface BlogsListProps {
    blogsCubit: IBlogsCubit;
    showCategories: boolean;
    title: string;
}

export default function BlogsList(props: BlogsListProps) {

    const blogsState: BlogsState = useCubit(props.blogsCubit);

    if (blogsState.state === 'LOADED') {

        return <Container style={{
            paddingTop: kNavBarHeight,
        }}>
            <h1 style={{
                marginTop: 16,
                paddingLeft: 12,
                paddingRight: 12,
                marginRight: "2vw",
                marginLeft: "2vw",
            }}>{`<${props.title} />`}</h1>
            <Row>
                <Col>
                    {blogsState.blogs!.map((blog, index) => <BlogElement blog={blog} key={`blog#${index}`} />)}
                </Col>
                {
                    window.innerWidth > 991 && props.showCategories && (blogsState.categories?.length ?? 0) > 0 && <Col xs={3}>
                        <div
                            style={{
                                marginTop: 28,
                            }}
                        >

                            <Card>
                                <CardTitle style={{ paddingLeft: 8, paddingTop: 8, paddingRight: 8 }}>{"<Categories />"}</CardTitle>
                                <CardBody>
                                    <p>
                                        {blogsState.categories?.map(cat => <CategoryBadge cat={cat} />)}
                                    </p>
                                </CardBody>
                            </Card>
                        </div>
                    </Col>
                }

            </Row>
        </Container>;
    }
    return <></>;

}